import React from "react";
import { DownOutlined } from "@ant-design/icons";
import {
  Row,
  Layout,
  Button,
  Modal,
  Typography,
  Switch,
  Popover,
  Col,
  Menu,
  Dropdown,
  Grid,
  Drawer,
  Badge,
  Tour,
  TourProps,
  Segmented,
  message,
} from "antd";
import { SearchProps } from "antd/es/input";
import { useEffect, useRef, useState } from "react";
import {
  StyledCardContent,
  StyledDateText,
  StyledMainContent,
  StyledModalSpan,
  StyledModalTag,
  StyledNewsCol,
  StyledNewsPageGenerateButton,
  StyledNewsRow,
  StyledSearch,
  StyledSearchCol,
  StyledSearchbar,
  StyledSegmented,
} from "./styles";
import { useDispatch, useSelector } from "react-redux";
import NewsBox from "./Components/NewsBox";
import { getGenerateArticle, getNewsData } from "../../Redux/Slice/DataSlice";
import {
  addNews,
  getGenres,
  getNews,
  getManualNews,
  getSources,
  clearCart,
} from "../../Redux/Slice/NewsSlice";
import { Filter } from "./Components/Filters";
import { useForm } from "antd/es/form/Form";
import Loader from "../../Components/Loader/Index";
import { Newslistbar } from "./Components/Newslistbar";
import { StyledModalClose } from "./Components/NewsCard/styles";
import { useNavigate } from "react-router-dom";
import { useKeycloak } from "@react-keycloak/web";
import NoPermission from "../../NoPermission";
import Cookies from "js-cookie";

const { Content } = Layout;
const { Text, Paragraph, Title } = Typography;
const { useBreakpoint } = Grid;

// Helper function to get the publication date from either fetched or reported news
const getPublicationDate = (article: any) => {
  return article?.articlePubDate || article?.created_at || "";
};

// Loading container component for better separation of concerns
const LoadingContainer: React.FC<{
  screens: any;
  newsSource: "fetched" | "reported";
}> = ({ screens, newsSource }) => {
  const loadingText = newsSource === "reported" ? "Fetching Reported News" : "Fetching News";

  return (
    <Row
      justify={screens.xs ? "center" : "start"}
      align="middle"
      style={{
        marginTop: screens.xs ? "0px" : "5px",
        height: "75vh",
        fontFamily: "Lato",
        marginLeft: screens.xs ? "30px" : "0px",
      }}
    >
      <Loader LoadingText={loadingText} />
    </Row>
  );
};

export const NewsList = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [ellipsis, setEllipsis] = useState(true);
  const [modelData, setModalData] = useState<any>({});
  const [visible, setVisible] = useState(false);
  const [filterForm]: any = useForm<any>();
  const [searchValue, setSearchValue] = useState("");
  const [genType, setGenType] = useState<String>("news");
  const [addedCards, setAddedCards] = useState([]);
  const [articleText, setArticleText] = useState("");
  const [newsCardView, setNewsCardView] = useState("cards");
  const [expanded, setExpanded] = useState(false);
  const expandedRef = useRef(null);
  const [showfilterDrawer, setShowfilterDrawer] = useState(false);

  const { keycloak } = useKeycloak();
  const screens = useBreakpoint();

  // Viewport-based checks for specific resolutions
  const [viewportWidth, setViewportWidth] = useState(window.innerWidth);
  const is720p = viewportWidth >= 1280 && viewportWidth < 1366;

  useEffect(() => {
    const handleResize = () => {
      setViewportWidth(window.innerWidth);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const [newsDrawerVisible, SetnewsDrawerVisible] = useState(false);
  const [open, setOpen] = useState(false);
  const [selectedLanguage, setSelectedLanguage] = useState<string>(
    localStorage.getItem("selectedLanguage") || "English",
  );
  const [newsSource, setNewsSource] = useState<"fetched" | "reported">(
    "reported",
  );

  const handleLanguageChange = (value: string) => {
    setSelectedLanguage(value);
    localStorage.setItem("selectedLanguage", value); // Store in localStorage
    message.destroy(); // Clear any existing messages
    const languageName =
      value === "English" ? "English" : value === "Urdu" ? "Urdu" : "Pashto";
    message.info(`News will be generated in ${languageName}`, 2);
  };

  const handleNewsSourceToggle = (checked: boolean) => {
    const newSource = checked ? "fetched" : "reported";
    setNewsSource(newSource);
    message.destroy();
    message.info(`Showing ${checked ? "RSS" : "Reported"} News`, 2);

    const { genres, sources, date, maxarticles } = filterForm.getFieldsValue([
      "genres",
      "sources",
      "date",
      "maxarticles",
    ]);

    const searchPayload = {
      search: "",
      sources,
      date,
      maxarticles,
      genres:
        genres && Array.isArray(genres) && genres.length > 0
          ? genres
          : undefined,
    };

    if (newSource === "reported") {
      dispatch(getManualNews({ ...searchPayload, token: keycloak.token }));
    } else {
      dispatch(getNews({ ...searchPayload, token: keycloak.token }));
    }
  };

  const showDrawer = () => {
    setOpen(true);
  };

  const { response: generatedArticle = [], loading: articleLoading } =
    useSelector((state: any) => state.data.generatedArticle);

  const [selectedGenres, setSelectedGenres] = useState<string[]>([]);

  const wordCount = modelData.content?.split(/\s+/).length;

  const handleNewsDrawerVIsible = (newVisible) => {
    SetnewsDrawerVisible(newVisible);
  };

  useEffect(() => {
    if (generatedArticle && generatedArticle !== "null") {
      setArticleText(generatedArticle);
    }
  }, [generatedArticle, articleText, setArticleText]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (expandedRef.current && !expandedRef.current.contains(event.target)) {
        setExpanded(false);
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    let searchPayload;
    if (genres && sources) {
      searchPayload = {
        // genres: genres,
        // sources: sources,
        paragraphs: paragraphs,
        words: words,
      };
    } else {
      searchPayload = {};
    }

    // Always fetch when newsSource changes or on initial load
    const shouldFetch =
      newsSource === "reported"
        ? manualArticles.length === 0
        : newsArticles.length === 0;

    if (shouldFetch) {
      if (newsSource === "reported") {
        dispatch(getManualNews({ ...searchPayload, token: keycloak.token }));
      } else {
        dispatch(getNews({ ...searchPayload, token: keycloak.token }));
      }
    }
    // dispatch(getSources());
    dispatch(getGenres());
  }, [dispatch, newsSource]);

  const handleClose = () => {
    setVisible(false);
  };

  const onClose = () => {
    setShowfilterDrawer(false);
  };

  const add = (item: any) => {
    dispatch(addNews(item));
    const itemId = item.article_id || item._id;
    setAddedCards(
      addedCards.includes(itemId)
        ? addedCards.filter((id) => id !== itemId)
        : [...addedCards, itemId],
    );
  };

  useEffect(() => {
    const handleScroll = () => {
      setTimeout(() => {
        handleNewsDrawerVIsible(false);
      }, 1);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const normalizeModalData = (item: any) => {
    return {
      ...item,
      genre: item.genre || item.genres || "General",
      source: item.source || item.created_by || "Manual Report",
    };
  };

  const showModal = (item) => {
    setModalData(normalizeModalData(item));
    setIsModalOpen(true);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };
  const {
    articles: newsArticles,
    loading: newsLoading,
    manualArticles,
    manualLoading,
  }: any = useSelector((state: any) => state.news);

  // Use the appropriate articles and loading state based on newsSource
  const currentArticles =
    newsSource === "reported" ? manualArticles : newsArticles;
  const currentLoading =
    newsSource === "reported" ? manualLoading : newsLoading;

  const filteredNewsArticles: any = Array.isArray(currentArticles)
    ? currentArticles.filter((obj: any) => {
        const hasContent =
          typeof obj?.content === "string" && obj?.content.trim() !== "";
        const wordCount = obj?.content?.split(/\s+/).length;
        // Different word count requirements for fetched vs reported news
        // Reported news snippets can be shorter (20+ words) vs full articles (100+ words)
        const minWordCount = newsSource === "reported" ? 20 : 100;
        const hasMinWords = wordCount >= minWordCount;
        const hasDate =
          (typeof obj?.articlePubDate === "string" &&
            obj?.articlePubDate.trim() !== "") ||
          (typeof obj?.created_at === "string" &&
            obj?.created_at.trim() !== "");

        return hasContent && hasMinWords && hasDate;
      })
    : [];

  const drawerData = useSelector((state: any) => state.news.selectedArticles);

  const { genres, sources, paragraphs, words } = useSelector(
    (state: any) => state.user.userData,
  );

  <Switch
    checked={ellipsis}
    onChange={() => {
      setEllipsis(!ellipsis);
    }}
  />;

  const onSearch: SearchProps["onSearch"] = (value: any) => {
    const { genres, sources, date, maxarticles } = filterForm.getFieldsValue([
      "genres",
      "sources",
      "date",
      "maxarticles",
    ]);

    const finalGenres =
      genres && Array.isArray(genres) && genres.length > 0 ? genres : undefined;
    const searchPayload = {
      search: value,
      sources,
      date,
      maxarticles,
      genres: finalGenres,
    };
    if (newsSource === "reported") {
      dispatch(getManualNews({ ...searchPayload, token: keycloak.token }));
    } else {
      dispatch(getNews({ ...searchPayload, token: keycloak.token }));
    }
  };

  const generateNews = async (data: any) => {
    // Generate news and navigate

    const contentArray = data.map((item, i) => {
      localStorage.removeItem("newsText");
      return { content: item.content };
    });

    // Normalize language: API returns "Arabic" or "English" (capitalized)
    // Convert to proper format for API: lowercase "english", "arabic", "urdu", or "pashto"
    const normalizeLanguageForAPI = (lang?: string) => {
      if (!lang) return "english";
      const lower = lang.toLowerCase();
      if (lower.startsWith("ar")) return "arabic";
      if (lower.startsWith("ur")) return "urdu";
      if (lower.startsWith("pa")) return "pashto";
      return "english";
    };

    // Use selected language instead of article's language
    const language = normalizeLanguageForAPI(selectedLanguage);

    // Proceed with the news generation
    if (genType === "news") {
      dispatch(
        getNewsData({
          articles: contentArray,
          gentype: genType,
          token: keycloak.token,
          language: language,
        }),
      );
    }

    // Navigate to the news screen after the generation is done
    navigate(`/News?language=${language}`);
  };

  const generateArticle = async (data: any) => {
    // Generate article and navigate

    const contentArray = data.map((item, i) => {
      localStorage.removeItem("artText");
      return item.content;
    });

    // Normalize language: API returns "Arabic" or "English" (capitalized)
    // Convert to proper format for API: lowercase "english", "arabic", "urdu", or "pashto"
    const normalizeLanguageForAPI = (lang?: string) => {
      if (!lang) return "english";
      const lower = lang.toLowerCase();
      if (lower.startsWith("ar")) return "arabic";
      if (lower.startsWith("ur")) return "urdu";
      if (lower.startsWith("pa")) return "pashto";
      return "english";
    };

    // Use selected language instead of article's language
    const language = normalizeLanguageForAPI(selectedLanguage);

    // Proceed with article generation
    dispatch(
      getGenerateArticle({
        articles: contentArray,
        token: keycloak.token,
        language: language,
      }),
    );

    // Navigate to the article screen after the generation is done
    navigate(`/Article?language=${language}`);
  };

  const handleClick = (callback: () => void) => {
    callback();
  };

  const handleAnnouncementNavigate = () => {
    navigate("/Announcement");
  };

  const menu = (
    <Menu>
      <Menu.Item
        key="1"
        onClick={() =>
          handleClick(() => {
            generateNews(drawerData);
          })
        }
        disabled={drawerData.length === 0}
        style={{ fontFamily: "Roboto", fontWeight: 400, fontSize: "14px" }}
      >
        News
      </Menu.Item>
      <Menu.Item
        key="2"
        onClick={() =>
          handleClick(() => {
            generateArticle(drawerData);
          })
        }
        disabled={drawerData.length === 0}
        style={{ fontFamily: "Roboto", fontWeight: 400, fontSize: "14px" }}
      >
        Article
      </Menu.Item>
      <Menu.Item
        key="3"
        onClick={() =>
          handleClick(() => {
            handleAnnouncementNavigate();
          })
        }
        style={{ fontFamily: "Roboto", fontWeight: 400, fontSize: "14px" }}
      >
        Announcement
      </Menu.Item>
    </Menu>
  );

  //Implementation of antd tour

  const step1 = useRef(null);
  const step2 = useRef(null);
  const step3 = useRef(null);

  const [startTour, setStartTour] = useState<boolean>(false);

  const steps: TourProps["steps"] = [
    {
      title: "Select Your Articles",
      description: (
        <span style={{ fontStyle: "Open Sans" }}>
          Select your articles from here.
        </span>
      ),

      target: () => step1.current,
    },
    {
      title: "View Selected Articles",
      description: (
        <span style={{ fontStyle: "Open Sans" }}>
          {" "}
          Here you can reorder your articles for proper generation
        </span>
      ),
      target: () => step2.current,
    },
    {
      title: "Content Generation",
      description: (
        <span style={{ fontStyle: "Open Sans" }}>
          Based on the selected articles you can generate News and Articles
        </span>
      ),
      target: () => step3.current,
    },
  ];

  useEffect(() => {
    // Check if the "tourtaken" cookie exists and is set to true
    const tourTaken = Cookies.get("tourtaken");
    if (tourTaken !== "true" && newsArticles.length !== 0 && !startTour) {
      // If not, open the tour
      setStartTour(true);
    }
  }, [newsArticles]);

  const handleTourFinish = () => {
    // Set a cookie when the tour finishes
    Cookies.set("tourtaken", String(true), { expires: 365 }); // expires in 1 year
    setStartTour(false);
  };

  // return (
  // const filterMenu = (
  //   <Menu>
  //     <Menu.Item>
  //       <Filter
  //         searchValue={searchValue}
  //         form={filterForm}
  //         handleClose={handleClose}
  //         setSelectedGenres={setSelectedGenres}
  //         selectedGenres={selectedGenres}
  //       />
  //     </Menu.Item>
  //   </Menu>
  // );

  return keycloak.authenticated ? (
    <StyledMainContent>
      <Drawer
        title="Filter Options"
        placement="right"
        closable={true}
        onClose={onClose}
        visible={showfilterDrawer}
        // bodyStyle={{ padding: "20px" }} // Optional: Style for the Drawer body
      >
        <Filter
          searchValue={searchValue}
          form={filterForm}
          handleClose={handleClose}
          setSelectedGenres={setSelectedGenres}
          selectedGenres={selectedGenres}
        />
      </Drawer>
      <Modal
        width={900}
        open={isModalOpen}
        onCancel={handleCancel}
        closeIcon={false}
        footer={[
          <StyledModalClose type="primary" onClick={handleCancel}>
            Close
          </StyledModalClose>,
        ]}
      >
        <Row justify={"space-between"}>
          <StyledModalSpan>{modelData.source}</StyledModalSpan>
          <StyledModalTag color="red">{modelData.genre}</StyledModalTag>
        </Row>
        <Row justify={"start"} style={{ marginTop: "30px" }}>
          <Title style={{ fontSize: "26px", fontFamily: "Inter" }}>
            {modelData?.title}
          </Title>
        </Row>
        <StyledDateText>
          {new Date(getPublicationDate(modelData)).toLocaleString()}
        </StyledDateText>

        <br></br>
        <br></br>
        <Row
          justify={"center"}
          style={{
            height: wordCount <= 400 ? "100%" : "50vh",
            overflow: "auto",
          }}
        >
          <Paragraph style={{ fontFamily: "Inter" }}>
            {modelData.content}
          </Paragraph>
        </Row>
      </Modal>
      <Row
        align={"middle"}
        justify={"center"}
        style={{
          background: "white",
          height: screens.xs ? "auto" : "100px",
          margin: "0px",
          padding: screens.xs ? "15px 0" : "0px",
        }}
      >
        <StyledSearchCol
          xs={22}
          sm={22}
          md={9}
          lg={{ span: 9, offset: 0 }}
          xl={{ span: 9, offset: 0 }}
          style={{ marginBottom: screens.xs ? "10px" : "0px" }}
        >
          <StyledSearchbar>
            <StyledSearch
              placeholder="Search"
              onSearch={onSearch}
              style={{ width: "100%" }}
              enterButton
              onChange={(e) => setSearchValue(e.target.value)}
              loading={currentLoading} // If StyledSearch supports loading
              disabled={currentLoading} // Or fallback to disabling it
            />
          </StyledSearchbar>
        </StyledSearchCol>
        <Col
          xs={22}
          sm={22}
          md={10}
          lg={{ span: 10, offset: 1 }}
          xl={{ span: 10, offset: 1 }}
          style={{
            display: "flex",
            justifyContent: screens.xs ? "center" : "flex-end",
            alignItems: "center",
            overflow: "hidden",
            maxWidth: "100%",
          }}
        >
          <Row
            justify={screens.xs ? "center" : "end"}
            align={"middle"}
            style={{
              display: "flex",
              width: screens.xs ? "100%" : is720p ? "100%" : screens.md || screens.lg ? "80%" : "50%",
              maxWidth: "100%",
              justifyContent: screens.xs ? "center" : "flex-end",
              gap: screens.xs ? "8px" : "0px",
              flexWrap: "wrap",
            }}
          >
            {drawerData.length !== 0 ? (
              <>
                <Popover
                  style={{ border: "1px solid grey", zIndex: 0 }}
                  content={
                    <div style={{ maxHeight: "70vh", overflowY: "auto" }}>
                      <Col lg={{ span: 22, offset: 1 }}>
                        <Newslistbar
                          showModal={showModal}
                          drawerData={drawerData}
                        />
                      </Col>
                    </div>
                  }
                  trigger="click"
                  visible={newsDrawerVisible}
                  onVisibleChange={handleNewsDrawerVIsible}
                >
                  <Badge
                    count={drawerData.length}
                    size="small"
                    offset={[-5, 5]}
                  >
                    <Button
                      ref={step2}
                      type="link"
                      style={{
                        fontFamily: "Lato",
                        fontSize: screens.xs ? "14px" : "18px",
                        color: "red",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        padding: screens.xs ? "4px 8px" : undefined,
                      }}
                      onClick={showDrawer}
                    >
                      View Selected
                    </Button>
                  </Badge>
                </Popover>
              </>
            ) : (
              <Badge
                count={0}
                size="small"
                offset={[-5, 5]}
                showZero
                color="grey"
              >
                <Button
                  ref={step2}
                  type="link"
                  style={{
                    fontFamily: "Lato",
                    fontSize: screens.xs ? "14px" : "18px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    padding: screens.xs ? "4px 8px" : undefined,
                  }}
                  onClick={showDrawer}
                  disabled
                >
                  View Selected
                </Button>
              </Badge>
            )}
            <Col
              flex={screens.xs ? "none" : "auto"}
              style={{
                minWidth: screens.xs ? "auto" : "120px",
                maxWidth: screens.xs ? "none" : is720p ? "180px" : "200px",
                marginLeft: screens.xs ? "0px" : is720p ? "5px" : "10px",
              }}
            >
              <StyledSegmented
                value={selectedLanguage}
                onChange={(value) => handleLanguageChange(value as string)}
                options={[
                  { label: "EN", value: "English" },
                  { label: "UR", value: "Urdu" },
                  { label: "PS", value: "Pashto" },
                ]}
                style={{
                  width: screens.xs ? "80px" : is720p ? "45%" : "40%",
                  fontSize: screens.xs ? "12px" : undefined
                }}
              />
            </Col>
            <Col flex="none" style={{ marginLeft: screens.xs ? "0px" : "-8px" }}>
              <Dropdown overlay={menu}>
                <StyledNewsPageGenerateButton
                  type="primary"
                  ref={step3}
                  style={{
                    fontSize: screens.xs ? "14px" : "16px",
                    width: screens.xs ? "110px" : "130px",
                    padding: screens.xs ? "15px" : "20px",
                  }}
                >
                  Generate <DownOutlined style={{ marginLeft: "5px" }} />
                </StyledNewsPageGenerateButton>
              </Dropdown>
            </Col>
          </Row>
        </Col>
      </Row>

      <Row
        align={"middle"}
        style={{ marginTop: screens.xs ? "5px" : "20px" }}
        justify={"center"}
      >
        <Col
          lg={20}
          md={22}
          sm={23}
          xs={23}
          style={{
            marginBottom: screens.xs ? "20px" : "10px",
            marginTop: screens.xs ? "15px" : "0px",
          }}
        >
          <div
            style={{
              background: screens.xs ? "transparent" : "white",
              boxShadow: screens.xs
                ? "none"
                : "0px 5px 5px rgba(211, 211, 211, 0.5)",
              minHeight: screens.xs ? "auto" : "50px",
              borderRadius: "10px",
              padding: screens.xs ? "10px 0" : "10px 15px",
              display: "flex",
              alignItems: "center",
              width: "100%",
            }}
          >
            {screens.xl && (
              <Text
                style={{
                  fontWeight: "700",
                  marginLeft: "5px",
                  marginRight: "10px",
                  whiteSpace: "nowrap",
                }}
              >
                Filters:
              </Text>
            )}
            <Filter
              searchValue={searchValue}
              form={filterForm}
              handleClose={handleClose}
              setSelectedGenres={setSelectedGenres}
              selectedGenres={selectedGenres}
              newsSource={newsSource}
              handleNewsSourceToggle={handleNewsSourceToggle}
            />
          </div>
        </Col>
      </Row>
      {/* <Row align={"middle"}>
        <Col
          lg={{ span: 20, offset: 2 }}
          xs={0}
          style={{ marginBottom: "10px" }}
        >
          <HorizontalSlider
            genres={newsGenres.genres}
            selectedGenres={selectedGenres}
            onGenreSelect={setSelectedGenres}
          />
        </Col>
      </Row> */}

      <Row justify="center">
        <Col
          sm={22}
          xs={23}
          md={22}
          lg={22}
          style={{
            backgroundColor: "transparent",
            transition: expanded ? "width 0.5s ease" : "none",
            overflowY: "hidden",
          }}
        >
          <StyledNewsRow>
            <StyledNewsCol
              lg={{ span: 22, offset: 1 }}
              sm={24}
              xs={24}
              md={24}
            >
              {currentLoading ? (
                <LoadingContainer
                  screens={screens}
                  newsSource={newsSource}
                />
              ) : (
                <StyledCardContent>
                  <div ref={step1}>
                    <NewsBox
                      news={filteredNewsArticles}
                      addedCards={addedCards}
                      add={add}
                      newsCardView={newsCardView}
                    />
                  </div>
                </StyledCardContent>
              )}
            </StyledNewsCol>
          </StyledNewsRow>
        </Col>
        <Tour open={startTour} onClose={handleTourFinish} steps={steps} />
      </Row>
    </StyledMainContent>
  ) : (
    <NoPermission />
  );
};

export default NewsList;
